import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { InputTextarea } from 'primereact/inputtextarea';
import { Menu } from 'primereact/menu';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import PowerAI from '../../assets/PowerAI.png';
import { CoachingTabs } from '../../utils/typeConstants';
import { useGetVertexAIFeedbackMutation } from './vertexAISlice';
import { AiMenuOptions, getAiMenuOptionValue, vertexAIProps } from './vertexAIType';

const VertexAI = ({ aiInputText, setTextAreaValue, aiMaxLength, via, tabIndex  }: vertexAIProps) => {
    const [VertexAIFeedback] = useGetVertexAIFeedbackMutation();

    const [aiResponse, setAIResponse] = useState<string>('');

    const [openAIMdodel, setOpenAIModel] = useState<boolean>(false);
    const [aiMode, setAIMode] = useState<string>('');

    const menu = useRef<Menu>(null);
    const items = [];
    const allMenuItems = [
        {
            label: AiMenuOptions.Summarize,
            command: () => {
                onAIAssistSelected('Summarize');
            },
        },
        { separator: true, visible: true },
        {
            label: AiMenuOptions.Bullets,
            command: () => {
                onAIAssistSelected('Bullets');
            },
            excludeWhen: via === CoachingTabs.shoutOut,
        },
        { separator: true, visible: true, excludeWhen: via === CoachingTabs.shoutOut },
        {
            label: AiMenuOptions.Clarity,
            command: () => {
                onAIAssistSelected('Clarity');
            },
        },
        { separator: true, visible: true },
        {
            label: AiMenuOptions.Positivity,
            command: () => {
                onAIAssistSelected('Positivity');
            },
        },
        { separator: true, visible: true, excludeWhen: via === CoachingTabs.shoutOut },
        {
            label: AiMenuOptions.Goals,
            command: () => {
                onAIAssistSelected('Goals');
            },
            excludeWhen: via === CoachingTabs.shoutOut,
        },
    ];

    items.push(...allMenuItems.filter((item) => !item.excludeWhen));

    const onAIAssistSelected = (selectedItem: string) => {
        setAIMode(selectedItem);
    };

    const popupMenuClickHandler = (e: any) => {
        if (aiInputText?.length === 0) {
            toast.warn('Please enter some text to get AI feedback');
            return;
        }
        e.preventDefault();
        menu.current?.toggle(e);
    };

    const handleDiscard = () => {
        setOpenAIModel(false);
        setAIMode('');
    };

    const handleAccept = () => {
        handleDiscard();
        setTextAreaValue(aiResponse);
    };

    const handleRetry = () => {
        vertexAIFeedbackRequest();
    };

    const vertexAIFeedbackRequest = () => {
        if (aiMode !== '') {
            const data = {
                text: aiInputText ?? null,
                mode: aiMode ?? null,
                maxLength: aiMaxLength,
            };
            VertexAIFeedback(data)
                .unwrap()
                .then((res: any) => {
                    if (res) {
                        setAIResponse(res?.response?.replace(/(##|\*\*)/g, ''));
                        setOpenAIModel(true);
                    }
                })
                .then((error: any) => {
                    console.log(error);
                });
        }
    };

    useEffect(() => {
        vertexAIFeedbackRequest();
    }, [aiInputText, aiMode]);

    const renderFooter = (
        <div>
            <Button
                label="Accept"
                style={{ background: '#7D71E2' }}
                className="btn-primary me-2"
                onClick={handleAccept}
            />
            <Button
                label="Discard"
                style={{ color: '#7D71E2' }}
                className="btn-secondary me-2"
                onClick={handleDiscard}
            />
            <Button
                label="Retry"
                style={{ color: '#7D71E2' }}
                className="btn-secondary"
                onClick={handleRetry}
            />
        </div>
    );

    const renderHeader = () => {
        return (
            <div>
                <div className="row mt-2">
                    <img src={PowerAI} alt="Power AI" style={{ width: '70px' }} className="col-2" />

                    <h2 className="col-5" style={{ color: '#7D71E2' }}>
                        Power AI
                    </h2>
                </div>
                <span className="mt-2 mb-2 fw-light">{getAiMenuOptionValue(aiMode)}</span>
                <Divider />
                <h5 className="mt-2 mb-2">Output:</h5>
            </div>
        );
    };

    const renderAIAssistant = () => {
        return (
            <Dialog
                header={renderHeader()}
                visible={openAIMdodel}
                style={{ width: '70vw' }}
                footer={renderFooter}
                onHide={handleDiscard}
            >
                <InputTextarea rows={15} className="borderRadius8 w-100" readOnly value={aiResponse} />
            </Dialog>
        );
    };

    return (
        <div>
            {openAIMdodel && renderAIAssistant()}
            <Menu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />
            <button
                className="justify-content-left float-end"
                onClick={(e: any) => {
                    popupMenuClickHandler(e);
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        popupMenuClickHandler(e);
                    }
                }}
                style={{ background: 'none', border: 'none', padding: 0 }}
                tabIndex={tabIndex}
            >
                <img
                    src={PowerAI}
                    alt="Power AI"
                    style={{
                        cursor: 'pointer',
                        width: '32px',
                        display: aiInputText?.length === 0 ? 'none' : '',
                    }}
                />
            </button>
        </div>
    );
};

export default VertexAI;
